import script from "./DigitalMarketingView.vue?vue&type=script&setup=true&lang=js"
export * from "./DigitalMarketingView.vue?vue&type=script&setup=true&lang=js"

import "./DigitalMarketingView.vue?vue&type=style&index=0&id=572bacf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-572bacf2"]])

export default __exports__